import React from 'react';
import { Routes, Route } from 'react-router-dom';
import CleaningDetailList from './CleaningDetailList';
import CleaningDetailForm from './CleaningDetailForm';

const CleaningDetails = () => (
  <Routes>
    <Route index element={<CleaningDetailList />} />
    <Route path="new" element={<CleaningDetailForm />} />
    <Route path=":id/edit" element={<CleaningDetailForm />} />
  </Routes>
);

export default CleaningDetails;
